var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":`/assets/img/logo-text.png`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }